<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Maintenance Activity
          </div>
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
            <v-avatar>
              <v-icon>assured_workload</v-icon>
            </v-avatar>
            <span v-if="this.getDetailChar.comp !== ''">
              {{this.getDetailChar.comp}}
            </span>
            <span v-else>
              NA
            </span>
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs6>
            <v-text-field
            :label="this.getDetailChar.type"
            prepend-icon="grid_view"
            hint="plan type"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            :label="this.getDetail.strategy.char.type"
            prepend-icon="settings_suggest"
            hint="plan theme"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs6>
            <v-text-field
            :label="this.getDetail.strategy.char.dis"
            prepend-icon="engineering"
            hint="activity discipline"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            :label="this.getDetail.strategy.char.driver"
            prepend-icon="water_drop"
            hint="strategy driver"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> list_alt </v-icon>
            </v-avatar>
            {{this.getTasksList.length}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> person </v-icon>
            </v-avatar>
            {{this.getResourcesList.length}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> shopping_bag </v-icon>
            </v-avatar>
            {{this.getPartsList.length}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> article </v-icon>
            </v-avatar>
            {{this.getPermitsList.length}}
          </v-chip>
          <v-spacer/>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Plan and Resources
          </div>
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
          v-if="this.getDetail.char.pri !== ''">
            <v-avatar>
              <v-icon>priority_high</v-icon>
            </v-avatar>
            {{this.getDetail.char.pri}}
          </v-chip>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> emoji_transportation </v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.getAssetRegister.length}}
              </div>
          </v-chip>
        </v-layout>
        <v-layout row class="ml-2">
          <span :class="ui.textSubheading">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>
                  {{this.getDetail.trans.flow[this.getDetail.trans.flow.length - 1].icon}}
                </v-icon>
              </v-avatar>
              {{this.getDetail.trans.flow[this.getDetail.trans.flow.length - 1].title}}
            </v-chip>
          </span>
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
            <v-avatar>
              <v-icon>schedule</v-icon>
            </v-avatar>
            {{dateTimeAgo(this.getDetail.stats.dcrt)}}
          </v-chip>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs6>
            <v-text-field
            :label="this.calcTotalEstimateCost(this.getResourcesList, this.getPartsList, this.getAssetRegister.length)"
            prepend-icon="attach_money"
            hint="plan cost"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            :label="this.calcPartsListCarbon(this.getPartsList, this.getAssetRegister.length)"
            prepend-icon="co2"
            hint="carbon cost"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs6>
            <v-text-field
            :label="this.getDetailChar.last"
            prepend-icon="work"
            hint="last call"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            :label="dateTypeA(this.getDetail.stats.dcall)"
            prepend-icon="event_repeat"
            hint="last due date"
            readonly
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";

export default {
  data() {
    return {
      valid: true
    };
  },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    dateFunctions,
    financeFunctions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getTasksList",
      "getPartsList",
      "getPermitsList",
      "getResourcesList",
      "getAssetRegister"
    ])
  }
};
</script>
